import { useSearchParams, usePathname, useRouter } from 'next/navigation';

const useURLParams = () => {
  /*  TODO - Input Validations - useSearchParams: The search param object should contain key value pairs where
  the value is of string type, not including reservered url special / unsafe characters like / \ & ? = : % + ' " ; < > { } [ ] @ #
  */
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const { replace } = useRouter();
  /*
    TODO - Input Validations - usePathName: string except the
    generalRestrictedCharacters (@\constants\securityConstants.ts)
  */
  const pathname = usePathname();

  const keyParams = (key: string, value: string) => {
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
  };

  //using window.history.pushState to avoid delay in updating URL params
  const setParamsWithWindows: (key: string, value: string) => void = (
    key,
    value
  ) => {
    keyParams(key, value);
    window.history.pushState(null, '', `?${params.toString()}`);
  };

  const setParams: (key: string, value: string, scroll?: boolean) => void = (
    key,
    value,
    scroll = false
  ) => {
    keyParams(key, value);
    replace(`${pathname}?${params.toString()}`, { scroll });
  };

  const getParam = (key: string) => params.get(key);

  const deleteParams = (key: string) => {
    params.delete(key);
    window.history.replaceState(null, '', `?${params.toString()}`);
  };

  const checkParamsHas = (key: string) => {
    return params.has(key);
  };

  return {
    setParams,
    setParamsWithWindows,
    getParam,
    deleteParams,
    checkParamsHas
  };
};

export default useURLParams;
